export const fieldLabelsAO = {
  //AO tab
  title: "Title",
  source: "Source",
  query: "Query",
  apprenticeshipStandard: "Apprenticeship standard title",
  assessmentPlanVersionNumber: "Assessment plan version number",
  queryClassification: "Query classification",
  queryFlag: "Query flag",
  attachments: "Attachments",
  organisationId: "Organisation",
};

export const fieldLabelsOfq = {
  //Engagement activity
  title: "Title",
  engagementActivity: "Engagement activity",
  Description: "Description",
  notes: "Notes",

  //Assessment plean recommendations
  proprosedShortTermSolution: "Proposed short term solution",
  proposedlongTermSolution: "Proposed long term solution",
  fitForPurpose: "Fit for purpose",

  //EPAO actions and recommendations
  epaosContacted: "EPAOs contacted",
  type: "Type",
  areaForImprovement: "Area of improvement",
  priority: "Priority",
  longDescription: "Long description",

  //Files
  attachments: "Attachments",

  //Other org
  stakeholderType: "Stakeholder Type",
  nonAoOrgName: "Other"
};
